/** 3 стола (D1) — в каноническом порядке возрастания. */
export const TABLE_IDS = Object.freeze([0, 1, 2]);
/** 3 линии в столе (D1) — в каноническом порядке возрастания. */
export const LANE_INDEXES = Object.freeze([0, 1, 2]);
/** Стороны в каноническом порядке: 'A' < 'B' (tech/21 §9). */
export const SIDES = Object.freeze(['A', 'B']);
/** Каноничная строка cellId: `T{t}-L{l}-{side}` (tech/21 §2, game/10 §5). */
export function cellId(tableId, laneIndex, side) {
    return `T${tableId}-L${laneIndex}-${side}`;
}
const CELL_ID_RE = /^T([0-2])-L([0-2])-([AB])$/;
/** Обратный разбор cellId; бросает на неканоничной строке. */
export function parseCellId(id) {
    const m = CELL_ID_RE.exec(id);
    if (!m) {
        throw new Error(`Некорректный cellId: "${id}" (канон: "T{0..2}-L{0..2}-{A|B}")`);
    }
    const [, t, l, s] = m;
    return {
        tableId: Number(t),
        laneIndex: Number(l),
        side: s,
    };
}
/**
 * Ячейка «напротив» (game/10 §3): та же линия того же стола, противоположная
 * сторона. Отношение взаимно и однозначно (инволюция): opposing(opposing(x)) === x.
 */
export function opposing(id) {
    const { tableId, laneIndex, side } = parseCellId(id);
    return cellId(tableId, laneIndex, side === 'A' ? 'B' : 'A');
}
function buildCanonicalCellOrder() {
    const order = [];
    for (const t of TABLE_IDS) {
        for (const l of LANE_INDEXES) {
            for (const s of SIDES) {
                order.push(cellId(t, l, s));
            }
        }
    }
    return Object.freeze(order);
}
/**
 * Все 18 cellId в каноническом порядке (tableId ASC, laneIndex ASC, 'A' < 'B') —
 * единый порядок обхода для триггеров/боя (tech/21 §9). Иммутабельная константа.
 */
export const canonicalCellOrder = buildCanonicalCellOrder();
/** Компаратор ячеек по каноническому порядку (tableId ASC, laneIndex ASC, 'A' < 'B'). */
export function compareCellIds(a, b) {
    const pa = parseCellId(a);
    const pb = parseCellId(b);
    if (pa.tableId !== pb.tableId)
        return pa.tableId - pb.tableId;
    if (pa.laneIndex !== pb.laneIndex)
        return pa.laneIndex - pb.laneIndex;
    if (pa.side === pb.side)
        return 0;
    return pa.side === 'A' ? -1 : 1;
}
/**
 * Тай-брейк канонического порядка для сущностей без ячейки — по ЧИСЛОВОМУ seq
 * (D26/R13): именно число, а не лексикографическая строка id — иначе "i2"
 * встал бы «после» "i100".
 */
export function compareSeq(a, b) {
    return a.seq - b.seq;
}
/**
 * Детерминированная фабрика доски: ровно 18 пустых ячеек (D1) с уникальными
 * cellId, вставленных в каноническом порядке (стабильный порядок обхода, tech/21 §9).
 */
export function initBoard() {
    const cells = {};
    for (const id of canonicalCellOrder) {
        const { tableId, laneIndex, side } = parseCellId(id);
        cells[id] = { id, tableId, laneIndex, side, occupantId: null };
    }
    return { cells };
}
//# sourceMappingURL=board.js.map